import { ThresholdGroup } from ".."

export function compareThresholds<T>(
   form: T,
   groupA: ThresholdGroup<T>,
   groupB: ThresholdGroup<T>,
   compare: (a: number, b: number) => boolean
) {
   const a = form[groupA.key]
   const b = form[groupB.key]

   return typeof a === "number" && typeof b === "number" && compare(a, b)
}
